import { render, staticRenderFns } from "./GreekFlagIcon.vue?vue&type=template&id=78b1e71c&"
import script from "./GreekFlagIcon.vue?vue&type=script&lang=js&"
export * from "./GreekFlagIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports